import React from "react";

const Footer = () => {
  return (
    <footer id="tt-footer">
      <div className="footer-wrapper01">
        <div className="container container-fluid-xl">
          <div className="row f-col-wrapper">
            <div className="col-md-4">
              <a href="index.html" className="f-logo">
                <i className="icons-logo tt-icon"></i>
                <span className="tt-base-color">Sp</span>pinzy
              </a>
              <div className="f-text">
                We are professionals in the laundry and dry cleaning business,
                which means we always stay up to date on the latest technologies
                and cleaning methods.
              </div>
              <ul className="f-social">
                <li>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    className="icons-733635"
                    rel="noopener noreferrer"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    className="icons-59439"
                    rel="noopener noreferrer"
                  ></a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_blank"
                    className="icons-2111532"
                    rel="noopener noreferrer"
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    className="icons-733614"
                    rel="noopener noreferrer"
                  ></a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <h6 className="f-title">Contacts</h6>
              <ul className="f-info">
                <li>
                  <i className="icons-484169"></i> 8494 Signal Hill Road
                  Manassas, VA, 20110
                </li>
                <li>
                  <i className="icons-59252"></i> Mon-Fri: 8am - 5pm
                  <br />
                  Sat-Sun: 10am - 5pm
                </li>
                <li>
                  <a href="mailto:info@yourlaundrysite.com">
                    <i className="icons-1004017"></i> info@yourlaundrysite.com
                  </a>
                </li>
                <li>
                  <strong>
                    <a href="tel:1(800)765-43-21">
                      <i className="icons-4839471"></i> 1 (800) 765-43-21
                    </a>
                  </strong>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <h6 className="f-title">Newsletter Subscribe</h6>
              <form id="subscribeform" method="post" noValidate action="#">
                <div className="f-form">
                  <div className="f-form__label">
                    Sign up and receive our special offers.
                  </div>
                  <div className="f-form__input">
                    <input
                      type="text"
                      name="email"
                      className="form-control"
                      placeholder="Your e-mail address"
                    />
                  </div>
                  <div className="f-form__btn">
                    <div className="tt-btn">
                      <span className="mask">Subscribe now</span>
                      <button className="button" type="submit">
                        Subscribe now
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="container container-fluid-xl">
        <div className="f-holder">
          <div className="f-copyright">
            &copy; 2020 <span className="tt-base-color">Pro</span>Laundry. All
            Rights Reserved.
          </div>
          <ul className="f-link">
            <li>
              <a href="#">Terms and Conditions</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="bubbleContainer">
        <div className="bubble-1"></div>
        <div className="bubble-2"></div>
        <div className="bubble-3"></div>
        <div className="bubble-4"></div>
        <div className="bubble-5"></div>
        <div className="bubble-6"></div>
        <div className="bubble-7"></div>
        <div className="bubble-8"></div>
        <div className="bubble-9"></div>
        <div className="bubble-10"></div>
      </div>
    </footer>
  );
};

export default Footer;
